






















































import Parrot from "@/assets/images/parrot/HoldingMarker.svg?inline";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { SessionFeedback, UserSessionResult } from "../../types";
import { Getter, Action } from "vuex-class";
import moment from "moment";
import feedbackEditor from "@/components/editor/FeedbackEditorReview.vue";
import {
  fetchUserSessionFeedback,
  addCommentFeedback,
  deleteCommentFeedback
} from "@/api.ts";

@Component({
  components: {
    Parrot,
    feedbackEditor
  },
  filters: {
    moment(date: string) {
      return moment(date).format("l | h:mma");
    }
  }
})
export default class ReviewFeedback extends Vue {

  @Prop() private sessionID!: string;
  @Prop() private isSessionFeedbackApiFailed!: boolean;
  @Prop() private isCommentsFetched!: boolean;
  @Prop() private isManager!: boolean;

  @Action private setNewReviewCommentVisible!: any;
  @Action private setReviewCommentSelectedIndex!: any;
  @Action private setReviewCommentPlay!: any;
  @Action private setTranscriptStartIndex!: any;
  @Action private setTranscriptEndIndex!: any;

  @Getter private JWT!: string;
  @Getter private UID!: string;
  @Getter private transcriptStartIndex!: number;
  @Getter private transcriptEndIndex!: number;
  @Getter private reviewCommentSelectedIndex!: number;
  @Getter private newReviewCommentVisible!: boolean;
  @Getter private sessionFeedback!: SessionFeedback[];

  private isCommentEdit: boolean = false;
  private addLoading: boolean = false;
  private editLoading: boolean = false;
  
  @Watch("sessionFeedback")
  private onFeedbackComments() {
    if (this.sessionFeedback && this.sessionFeedback.length > 0) {
      this.editLoading = false;
      this.addLoading = false;
      this.isCommentEdit = false;
    }
  }

  @Watch("isSessionFeedbackApiFailed")
  private onFeedbackApiFailed() {
    
    if (this.isSessionFeedbackApiFailed) {
      this.editLoading = false;
      this.addLoading = false;
    }
  }

  @Watch("newReviewCommentVisible")
  private onNewReviewCommentVisible() {
    if (this.newReviewCommentVisible) {
      this.setReviewCommentSelectedIndex(-1);
      this.isCommentEdit = false;
    }
  }

  private addComment(comments: string, feedbackID: string) {
    if (comments && comments.length && comments !== '<p></p>' && this.sessionID) {
      let startIndex = -1;
      let endIndex = -1;
      if (feedbackID) {
        this.editLoading = true;
        let selectedFeedback = this.sessionFeedback[this.reviewCommentSelectedIndex]
        startIndex = selectedFeedback.StartIndex?selectedFeedback.StartIndex:-1;
        endIndex = selectedFeedback.EndIndex?selectedFeedback.EndIndex:-1;
      } else {
        this.addLoading = true;
        startIndex = this.transcriptStartIndex;
        endIndex = this.transcriptEndIndex;
      }
      addCommentFeedback(
        this.JWT,
        this.sessionID,
        comments,
        feedbackID,
        this.transcriptStartIndex,
        this.transcriptEndIndex,
        (response: SessionFeedback) => {
          this.$emit("fetchComments");
        },
        (error: string) => {
          this.error();
        }
      );
    }
  }

  private deleteComment(feedbackID: number) {
    if (this.sessionID && feedbackID) {
      this.editLoading = true;
      deleteCommentFeedback(
        this.JWT,
        this.sessionID,
        feedbackID.toString(),
        (response: any) => {
          this.addLoading = false;
          if (this.sessionFeedback) {
            this.$emit("fetchComments");
          }
        },
        (error: string) => {
          this.error();
        }
      );
    } else {
      this.error();
      this.setNewReviewCommentVisible(false);
      this.setTranscriptSelectionIndex(-1, -1);
    }
  }

  private error() {
    this.editLoading = false;
    this.addLoading = false;
  }

  private isCommentEditing(index: number) {
    return index === this.reviewCommentSelectedIndex && this.isCommentEdit;
  }

  private handleEditClick(event: Event, comment: any, commentIndex: number) {
    //event.stopPropagation();
    this.setNewReviewCommentVisible(false);
    this.setTranscriptSelectionIndex(-1,-1);
    this.isCommentEdit = true;
    this.setReviewCommentSelectedIndex(commentIndex);
  }

  private mouseOver(commentIndex: number) {
    if (this.isCommentEdit) {
        return;
    }
    this.setReviewCommentSelectedIndex(commentIndex);
  }

  private commentClick(commentIndex: number) {
    if (this.isCommentEdit) {
        return;
    }
    this.setReviewCommentPlay(commentIndex);
  }

  private mouseOut() {
    if (this.isCommentEdit) {
        return;
    }
    this.setReviewCommentSelectedIndex(-1);
  }

  private setTranscriptSelectionIndex(startIndex: number, endIndex: number) {
    this.setTranscriptStartIndex(startIndex);
    this.setTranscriptEndIndex(endIndex);
  }
  private getMonogram(name: string) {
    let words = name.split(" ");
    let mono = "";

    for (let i = 0; i < words.length; ++i) {
      mono += words[i].charAt(0).toUpperCase();
    }
    return mono;
  }
}
